import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const role = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Name - Unique role identifier'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Display Name - Human-readable role label'),

    description: z
      .string()
      .nullable()
      .optional()
      .describe('Description - Role purpose and permissions summary'),

    roleAssignments: hasMany('RoleAssignment', 'roleId'),

    userTasks: hasMany('UserTask', 'roleId'),

    myUserTasks: hasMany('MyUserTask', 'roleId'),
  })
  .describe('Named authorization role that can be assigned to users.')
  .as('Role');

export { role as roleSchema };
